import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var GetApproved = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'getApproved',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721', isPreview: true, }),
                methodParams: {
                    tokenId: new FctValue({}),
                },
            },
            output: {
                operator: new FctAddress({ innerIndex: 0 }),
            },
        });
    },
});
